import './js/wdyr';

import React from 'react';
import ReactDOM from 'react-dom';
import App from 'js/components/App';
import 'css/reset.css';
import 'css/index.css';

ReactDOM.render(<App />, document.getElementById('root'));
